import { useWeb3React } from "@web3-react/core";
import Page from "components/layout/Page";
import { NETWORK_CHAIN_ID } from "connectors";
import React, { useEffect } from "react";
import loadable from "@loadable/component";
import "./Home.scss";
import usePageState from "hooks/usePageState";
import useTimer from "hooks/useTimer";
const MetaMaskConnection = loadable(
  () => import("./components/MetaMaskConnection")
);

const MainContainer = loadable(() => import("./components/MainContainer"));

const NftSaleClosed = loadable(() => import("./components/NftSaleClosed"));

const Home: React.FC = () => {
  const { account, chainId } = useWeb3React();
  const { activeHoverboardScreen } = usePageState(); // this is use to change Page
  const { timerEnd } = useTimer();

  useEffect(() => {
    activeHoverboardScreen();
    // eslint-disable-next-line
  }, [account, chainId]);

  return (
    <div>
      <Page>
        {/*  When timer end sale closed component will render */}
        {timerEnd ? (
          <NftSaleClosed />
        ) : !account || NETWORK_CHAIN_ID !== chainId ? (
          <MetaMaskConnection />
        ) : (
          <MainContainer />
        )}
      </Page>
    </div>
  );
};

export default Home;
